import LoadingSpinner from "@/components/LoadingSpinner";
import { getUserID } from "@/lib/auth/auth-server-func";
import MainLayout from "@/lib/layout/MainLayout";
import { useNotifications } from "@/lib/tanstack-query/hooks/useNotifications";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { formatDistanceToNow } from "date-fns";
import { Loader2 } from "lucide-react";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

export const Route = createFileRoute("/_dashboard/notifications")({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    const userID = await getUserID();
    return { userID };
  },
  loader: async ({ context }) => {
    if (!context.userID) {
      throw redirect({ to: "/" });
    }
    return { userID: context.userID };
  },
});

function RouteComponent() {
  const { ref, inView } = useInView();
  const {
    data: notifications,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useNotifications();

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, inView, isLoading]);

  return (
    <>
      <MainLayout.Header headline="Notifications"></MainLayout.Header>
      <MainLayout.Content>
        {notifications?.pages.flatMap((page) =>
          page.map((notification, index) => {
            if (notification.type === "vote") {
              return (
                <div
                  className="text-neutral-text-wu grid grid-cols-[1fr_auto] gap-4"
                  key={notification.entityId + index}
                >
                  <div>
                    🔥 Your poll "
                    <span className="font-bold">
                      {notification.metadata?.pollQuestion}
                    </span>
                    " is heating up with {notification.count} votes! Check out
                    the top-voted option! 🎯
                  </div>
                  <p className="text-secondary-text-wu text-sm">
                    {formatDistanceToNow(notification.updatedAt, {
                      addSuffix: true,
                    })}
                  </p>
                </div>
              );
            }
          })
        ) ?? []}
      </MainLayout.Content>
      <div>
        {isLoading ? <LoadingSpinner /> : null}
        {hasNextPage ? <LoadingSpinner ref={ref} /> : null}
      </div>
    </>
  );
}
